import { mergeData, PartnerInfo, User, USERS, WithId, WithMetadata } from '@hb/shared'

export const toGynFormData = (type: 'data' | 'corrections', patient: WithId<User>) => {
  const gynData =
    type === 'data'
      ? patient.gyn?.data
      : mergeData(patient.gyn?.data ?? {}, patient.gyn?.corrections ?? {})

  const partnerInfo: Partial<WithMetadata<PartnerInfo>> =
    type === 'data'
      ? (patient.partnerInfo?.data ?? {})
      : mergeData(patient.partnerInfo?.data ?? {}, patient.partnerInfo?.corrections ?? {})

  return {
    contact: {
      patient,
      partner: partnerInfo,
      updatedOn: partnerInfo?.updatedOn,
      updatedBy: partnerInfo?.updatedBy,
      updatedByGroup: partnerInfo?.updatedByGroup,
      createdOn: partnerInfo?.createdOn,
      createdBy: partnerInfo?.createdBy,
      createdByGroup: partnerInfo?.createdByGroup,
    },
    insuranceInfo:
      type === 'data'
        ? (patient.insuranceInfo?.data ?? {})
        : mergeData(patient.insuranceInfo?.data ?? {}, patient.insuranceInfo?.corrections ?? {}),
    familyAndGeneticHistory: gynData?.familyAndGeneticHistory,
    healthHistory: gynData?.healthHistory,
    socialHistory: gynData?.socialHistory,
    gynAndSexualHistory: gynData?.gynAndSexualHistory,
    allergies: gynData?.allergies,
    medicationsAndSupplements: gynData?.medicationsAndSupplements,
    // sexualBehavior: history?.sexualBehavior,
    // conditionsOrDiseases: history?.conditionsOrDiseases,
    // neurologicalPsychological: history?.neurologicalPsychological,
    // injuriesAndSurgeries: history?.injuriesAndSurgeries,
    // immunizations: history?.immunizations,
  }
}

export const getGynStoragePath = (userId: string, stageId: string) => {
  switch (stageId) {
    case 'contact':
      return `${USERS}/${userId}/contact`
    case 'insuranceInfo':
      return `${USERS}/${userId}/insuranceInfo/data`
    default:
      return `${USERS}/${userId}/gyn/data/${stageId}`
  }
}
